export const REDUX_STATUSES = {
  pending: 'pending',
  fulfilled: 'fulfilled',
  rejected: 'rejected',
};
